import { TextField, MenuItem } from "@mui/material";
import * as React from "react";
import styled from "styled-components";
import BasicButtons from "../../UI/BasicButtons";
import { useCreateStreetMutation } from "../../../store/coefficientsApi/streetsApi";
import { useGetK1Query } from "../../../store/coefficientsApi/k1Api";

export default function Create({ onClose }) {
  const [addData] = useCreateStreetMutation();
  const { data: k1FB } = useGetK1Query("?sort[0]=id:asc");
  const [title, setTitle] = React.useState("");
  const [listOfK1, setListOfK1] = React.useState([]);
  const [k1, setK1] = React.useState("");

  React.useEffect(() => {
    const setDataToStates = async () => {
      try {
        const k1s = await k1FB.data;
        setListOfK1(k1s);
      } catch (error) {}
    };
    setDataToStates();
  }, [k1FB]);

  const inputChangeHandler = (event, setValue) => {
    setValue(event.target.value);
  };

  const formSubmitHandler = (event) => {
    event.preventDefault();
    window.confirm("Вы уверены?");
    const newData = {
      street: title,
      k_1: k1,
    };
    addData(newData);
    console.log(newData)
    onClose();
  };

  return (
    <StyledForm onSubmit={formSubmitHandler}>
      <TitleOfCreation>Категория улиц(К1)</TitleOfCreation>
      <BlockStyled width="100%" display="flex" justifyContent="flex-start">
        <TextFieldStylded
          id="outlined-basic"
          label="Наименование"
          variant="outlined"
          value={title}
          onChange={(event) => inputChangeHandler(event, setTitle)}
          size="small"
          width="60%"
          mrg="0 15px 0 0"
        />
        <TextFieldStylded
          id="select"
          select
          label="Категория"
          variant="outlined"
          width="50%"
          size="small"
          value={listOfK1.length ? k1 : ""}
        >
          {listOfK1.map((item) => {
            return (
              <MenuItem
                key={item.id}
                value={item.id}
                onClick={() => setK1(item.id)}
              >
                {item.attributes.title}
              </MenuItem>
            );
          })}
        </TextFieldStylded>
      </BlockStyled>

      <StyledButtonsdBlock>
        <BlockStyled
          display="flex"
          flexDirection="flex-start"
          alignItems="center"
        ></BlockStyled>

        <BlockStyled display="flex" flexDirection="flex-end">
          <BasicButtons onClick={onClose}>Отменить</BasicButtons>
          <BasicButtons type="submit">Сохранить</BasicButtons>
        </BlockStyled>
      </StyledButtonsdBlock>
    </StyledForm>
  );
}

const BlockStyled = styled.div`
  width: ${(props) => props.width};
  display: ${(props) => props.display};
  justify-content: ${(props) => props.justifyContent};
  flex-direction: ${(props) => props.flexDirection};
  margin: ${(props) => props.margin};
  padding: ${(props) => props.padding};
  align-items: ${(props) => props.alignItems};
`;

const TextFieldStylded = styled(TextField)`
  width: ${(props) => props.width};
  margin: ${(props) => props.mrg};
`;

const StyledButtonsdBlock = styled.div`
  width: 100%;
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
`;
const TitleOfCreation = styled.h3`
  text-align: center;
`;

const StyledForm = styled.form``;
